"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersistAddressResponseMapper = void 0;
var PersistAddressResponseMapper = /** @class */ (function () {
    function PersistAddressResponseMapper(data) {
        this.localData = data;
    }
    PersistAddressResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return PersistAddressResponseMapper;
}());
exports.PersistAddressResponseMapper = PersistAddressResponseMapper;
//# sourceMappingURL=PersistAddressResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/PersistAddressResponseMapper.js
// module id = 2072
// module chunks = 8